import { useEffect } from "react";
import { PageFrame } from "./PageFrame";
import { CenteredErrorIcon } from "@/frontend/@error/CenteredErrorIcon";
import { showCustomError } from "@/frontend/@error/ErrorManager";

export const NotFound = () => {
    useEffect(() => {
        showCustomError({
            title: "Page not found"
        });
    }, []);

    return (
        <PageFrame breadcrumbReplacement={<></>}>
            <CenteredErrorIcon />
        </PageFrame>
    );
};
